import React, { useEffect, useState } from "react";
import { Col, Row, Form, Image } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { withRouter } from "react-router-dom";
import DatePickerComponent from "../../DatePickerComponent";
import moment from "moment";
import { logger } from "../../../../Utils";
import { useSelector } from "react-redux";
import { updateRawData } from "../../../../Store/actions/RawDataAction";
import { TERMS_TEXT } from "../../../Landlord/Notices/helper";

const log = logger("SignatureForm");
const SignatureForm = (props) => {
  const {
    setSignData,
    notice_type,
    phoneError,
    noticeData,
    type,
    signUserType,
    disableError,
    hideAgreement,
    errors
  } = props;
  
  const redirectToInfo = () => {
    updateRawData({ allCleared: true })
    setTimeout(() =>
      props.history.push(`/notice-info/${notice_type}`), 300);

  };
  
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [signingName, setSigningName] = useState("");
  const [signDate, setSignDate] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [full_name_sign, setFull_name_sign] = useState(null);
  const [agree, setAgree] = useState(false);
  const [tenant_first_name, setTenantFirstName] = useState("");
  const [tenant_last_name, setTenantLastName] = useState("");
  const [tenant_phone_number, setTenantPhoneNumber] = useState("");
  const [tenant_sign_date, setTenantSignDate] = useState(null);
  const [tenant_signature, setTenantSignature] = useState(null);
  const rawData=useSelector((state)=>state.rawData)

  const onChangeHandler = (event, state) => {
    const re = /^[A-Za-z]+$/
    const value = event.target.value
    const name = event.target.name 
    if(value === '' ||re.test(value)){
      state(value)
      if(name === 'tenant_first_name' || name === 'tenant_last_name'){
        if(name === 'tenant_first_name'){
          createSignImage(value + ' ' + tenant_last_name, 'tenant')
        }else{          
          createSignImage(tenant_first_name + ' ' + value, 'tenant')
        }
      }else{
        if(name === 'firstName'){
          createSignImage(value + ' ' + lastName)
        }else{          
          createSignImage(firstName + ' ' + value)
        }
      }
    }
  }

  const onFullNameChange = (event, state) => {
    const re = /^[A-Za-z ]*$/
    const value = event.target.value
    const name = event.target.name 
    if(value === '' ||re.test(value)){
      state(value)
      if(name === 'signingName'){
          createSignImage(value)
      }
    }
  }

  const createSignImage = (value, type) => {
    const textToImage = require("text-to-image");
    textToImage
      .generate("\n\t" + value, {
        fontFamily: "Broetown-Signature",
        customHeight: 70,
        fontSize: 65,
        fontWeight:600,
        lineHeight: 15,
        margin: 20,
        textColor: "black",
      })
      .then(function (dataUri) {
        if (type === "tenant") {
          setTenantSignature(dataUri);
        } else {
          setFull_name_sign(dataUri);
        }
      });
  };

  useEffect(() => {
    console.log({tenant_phone_number,phoneNumber})
    setSignData({
      firstName: firstName,
      lastName: lastName,
      signingName: signingName,
      signDate: signDate || '',
      phoneNumber: phoneNumber?.toString().replace(/-/g,''),
      full_name_sign: full_name_sign,
      tenant_first_name: tenant_first_name,
      tenant_last_name: tenant_last_name,
      tenant_phone_number: tenant_phone_number?.toString().replace(/-/g,''),
      tenant_sign_date: tenant_sign_date,
      tenant_signature: tenant_signature,
      agree: agree
    });
  }, [
    firstName,
    lastName,
    signingName,
    signDate,
    phoneNumber,
    full_name_sign,
    tenant_first_name,
    tenant_last_name,
    tenant_phone_number,
    tenant_sign_date,
    tenant_signature,
    agree
  ]);


  useEffect(() => {
    if (noticeData && noticeData.landlord_signature) {
      setFirstName(noticeData.first_name);
      setLastName(noticeData.last_name);
      setSigningName(noticeData.full_name);
      setSignDate(moment(noticeData.date).toDate());
      setPhoneNumber(noticeData.phone_number);
      setFull_name_sign(noticeData.landlord_signature);
    }

    if (noticeData && noticeData.tenant_signature) {
      setTenantFirstName(noticeData.tenant_first_name);
      setTenantLastName(noticeData.tenant_last_name);
      setTenantPhoneNumber(noticeData.tenant_phone_number);
      setTenantSignDate(moment(noticeData.tenant_sign_date).toDate());

      setTenantSignature(noticeData.tenant_signature);

    }
  }, [noticeData.notice_type]);

  log.info("noticeData", noticeData);

  return signUserType === "tenant" ? (
    <>
      {type === "lastName" && (
        <Row>
          <Form.Group as={Col} md="5">
            <Form.Label>First Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="John"
              name="tenant_first_name"
              id="tenant_first_name"
              value={tenant_first_name}
              maxLength="30"
              onChange={(e) => {
                onChangeHandler(e, setTenantFirstName);
                // createSignImage(
                //   tenant_first_name + " " + tenant_last_name,
                //   "tenant"
                // );
              }}
            />
          </Form.Group>
          <Form.Group as={Col} md="5">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Doe"
              name="tenant_last_name"
              id="tenant_last_name"
              value={tenant_last_name}
              maxLength="30"
              onChange={(e) => {
                onChangeHandler(e, setTenantLastName);
                // createSignImage(
                //   tenant_first_name + " " + tenant_last_name,
                //   "tenant"
                // );
              }}
            />
          </Form.Group>
        </Row>
      )}
      <Row>
        <Form.Group as={Col} md="5">
          <Form.Label>Date</Form.Label>
          <DatePickerComponent
            id="tenant_sign_date"
            name="tenant_sign_date"
            format={"dd/MM/yyyy"}
            value={tenant_sign_date ? tenant_sign_date : ""}
            handleDateChange={(date) => setTenantSignDate(date)}
            minDate={new Date()}
            displayText={"Select or Type"}
            popperPlacement="bottom-end"
          />
        </Form.Group>

        <Form.Group as={Col} md="5">
          <Form.Label>Phone Number</Form.Label>
          <NumberFormat
            format="###-###-####"
            mask="_"
            placeholder="123-123-1234"
            name="tenant_phone_number"
            id="tenant_phone_number"
            className={
              phoneError === true ? "form-control is-invalid" : "form-control"
            }
            value={tenant_phone_number ? tenant_phone_number : ""}
            onChange={(e) => {
              setTenantPhoneNumber(e.target.value);
              disableError(false);
            }}
          />
          {phoneError && (
            <div className="invalid-select">phone number required</div>
          )}
        </Form.Group>
      </Row>

      <Row>
        <Form.Group as={Col} md="5" className="signature">
          <Form.Label>Esignature</Form.Label>
          <br />
          {tenant_signature && (
            <Image src={tenant_signature} alt="Sign Image" />
          )}
        </Form.Group>
      </Row>
      <div className="agree-info d-flex justify-content-start mt-4 mb-4">
        <input
          type="checkbox"
          className="checkit"
          id={"agree"}
          name={"agree"}
          checked={agree || rawData?.agree}
          onChange={()=>{
            setAgree(!agree)
            updateRawData({agree:!agree})
          }}
          hidden
        />
        <label htmlFor={"agree"} className="checkmark"></label>
        <span className="checkbox-title">I have read and agree with the</span>
        <span className="checkbox-subtitle" onClick={redirectToInfo}>
{ TERMS_TEXT[notice_type] ||          'Important information from the Landlord and Tenant Board'
}  
      </span>
      </div>
    </>
  ) : (
    <>
      {type === "lastName" ? (
        <Row>
          <Form.Group as={Col} md="5">
            <Form.Label>First Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="John"
              name="firstName"
              id="firstName"
              value={firstName}
              maxLength="30"
              onChange={(e) => {
                onChangeHandler(e, setFirstName);
                // createSignImage(firstName + " " + lastName);
              }}
            />
          </Form.Group>
          <Form.Group as={Col} md="5">
            <Form.Label>Last Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Doe"
              name="lastName"
              id="lastName"
              value={lastName}
              maxLength="30"
              onChange={(e) => {
                onChangeHandler(e, setLastName);
                // createSignImage(firstName + " " + lastName);
              }}
            />
          </Form.Group>
          
        </Row>
      ) : (
        <Row>
          <Form.Group as={Col} md="5">
            <Form.Label>Name Of Person Signing</Form.Label>
            <Form.Control
              type="text"
              placeholder="John"
              name="signingName"
              id="signingName"
              value={signingName}
              maxLength="30"
              onChange={(e) => {
                onFullNameChange(e, setSigningName);
                // createSignImage(e.target.value);
              }}
            />
          </Form.Group>
          <Form.Group as={Col} md="5">
          <Form.Label>Phone Number</Form.Label>
          <NumberFormat
            format="###-###-####"
            mask="_"
            placeholder="123-123-1234"
            name="phoneNumber"
            id="phoneNumber"
            className={
              phoneError === true ? "form-control is-invalid" : "form-control"
            }
            value={phoneNumber ? phoneNumber : ""}
            onChange={(e) => {
              setPhoneNumber(e.target.value);
              disableError(false);
            }}
          />
          {phoneError && (
            <div className="invalid-select">phone number required</div>
          )}
        </Form.Group>
        </Row>
      )}
      <Row>
        <Form.Group as={Col} md="5">
          <Form.Label>Date</Form.Label>
          <DatePickerComponent
            id="signingDate"
            name="signingDate"
            format={"dd/MM/yyyy"}
            value={signDate ? signDate : ""}
            handleDateChange={(date) => setSignDate(date)}
            minDate={new Date()}
            displayText={"Select or Type"}
            popperPlacement="bottom-end"
          />
        </Form.Group>

       {type === "lastName" && <Form.Group as={Col} md="5">
          <Form.Label>Phone Number</Form.Label>
          <NumberFormat
            format="###-###-####"
            mask="_"
            placeholder="123-123-1234"
            name="phoneNumber"
            id="phoneNumber"
            className={
              phoneError === true ? "form-control is-invalid" : "form-control"
            }
            value={phoneNumber ? phoneNumber : ""}
            onChange={(e) => {
              setPhoneNumber(e.target.value);
              disableError(false);
            }}
          />
          {phoneError && (
            <div className="invalid-select">phone number required</div>
          )}
        </Form.Group>}
      </Row>

      <Row>
        <Form.Group as={Col} md="5" className="signature">
          <Form.Label>Esignature</Form.Label>
          <br />
          {full_name_sign && <Image src={full_name_sign} alt="Sign Image" />}
        </Form.Group>
      </Row>
      {hideAgreement ? null : (
        <div className="agree-info d-flex justify-content-start mt-4 mb-4">
          <input
            type="checkbox"
            className="checkit"
            id={"agree"}
            name={"agree"}
            checked={agree || rawData?.agree}
            onChange={()=>{
              setAgree(!agree)
              updateRawData({agree:!agree})
            }}
            hidden
          />
          <label htmlFor={"agree"} className="checkmark"></label>
          <span className="checkbox-title">I have read and agree with the</span>
          <span className="checkbox-subtitle" onClick={redirectToInfo}>
          { TERMS_TEXT[notice_type] ||          'Important information from the Landlord and Tenant Board'}  
          </span>
        </div>
      )}
    </>
  );
};
export default withRouter(SignatureForm);
